export default __webpack_public_path__ + "static/media/561.99bf446a.jpg";